<template>
  <section class="content-section faq-wrap">
    <div class="section-heading">
      <h2>{{ title }}</h2>
    </div>
    <div class="faq-list">
      <article v-for="(item, index) in items" :key="item.question" class="faq-item" :class="{ open: activeIndex === index }">
        <button class="faq-q" type="button" @click="toggle(index)">
          <span>{{ item.question }}</span>
          <img src="@/assets/down-black.svg" alt="" :class="{ rotate: activeIndex === index }">
        </button>
        <div v-show="activeIndex === index" class="faq-a" v-html="item.answer" />
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FaqList',
  props: {
    title: {
      type: String,
      default: 'Frequently Asked Questions',
    },
    items: {
      type: Array,
      required: true,
    },
    openFirst: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeIndex: this.openFirst ? 0 : null,
    };
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>
